import axios from 'axios';
import apiConfig from '../api.config';

export default function getGuestlinkSmtpConfig({ hotelId }) {
  const {
    host,
    URIs: { guestlinkSmtpConfig },
  } = apiConfig;

  const uri = `${host}${guestlinkSmtpConfig.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
